import React from 'react';
import { useTheme } from '@emotion/react';
import { Grid, IconButton, Paper, Typography } from '@mui/material';
import { ReactComponent as CloseIcon } from "assets/close_icon.svg";
import ModalComponent from 'ui-components/ModalComponent';
import { Primary, Secondary } from 'ui-components/Buttons';

/**
 * A stop before a change customers will notice.
 *
 * The body says what happens to visitors and what happens to people already
 * subscribed, because those differ and the second one is the part that worries
 * anyone who has not done this before.
 */
const ConfirmDialog = ({ open, title, body, confirmLabel = 'Confirm', onCancel, onConfirm }) => {
    const theme = useTheme();
    if (!open) return null;

    return (
        <ModalComponent open={open} onClose={onCancel} style={{ maxWidth: 480, width: "100%" }}>
            <Paper sx={{ background: theme.palette.customColors.whiteBG, borderRadius: '8px' }}>
                <IconButton sx={{ position: "absolute", top: 20, right: 20, padding: 0 }} onClick={onCancel}>
                    <CloseIcon width={40} height={40} />
                </IconButton>

                <Grid display="grid" container padding={"1.5rem"} gap={"1.25rem"}>
                    <Grid item xs={12}>
                        <Typography sx={{
                            fontSize: '1.125rem',
                            fontWeight: 700,
                            color: theme.palette.customColors.g300,
                            paddingRight: '2.5rem',
                        }}>
                            {title}
                        </Typography>
                        <Typography sx={{
                            fontSize: '0.875rem',
                            color: theme.palette.customColors.g200,
                            marginTop: '0.5rem',
                            maxWidth: '52ch',
                        }}>
                            {body}
                        </Typography>
                    </Grid>

                    <Grid item xs={12} display="flex" justifyContent="flex-end" gap={1.5}>
                        <Secondary onClick={onCancel} sx={{ padding: '0.625rem 1.5rem' }}>Cancel</Secondary>
                        <Primary onClick={onConfirm} sx={{ padding: '0.625rem 1.5rem' }}>{confirmLabel}</Primary>
                    </Grid>
                </Grid>
            </Paper>
        </ModalComponent>
    );
};

export default ConfirmDialog;
